import React from 'react';

const PaymentConfiguration = ({ color = '#000000', height = '17', width = '17' }) => {
    return (
        <div style={{ display: 'inline-flex' }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 40"
            width={width}
            height={height}
            style={{
              height: 'auto',
              fill: color,
              color: color,
            }}
          >
            <path
              d="M0 0 C2.41432578 1.17691507 4.6037112 2.35228381 6.875 3.75 C7.46796875 4.08515625 8.0609375 4.4203125 8.671875 4.765625 C10.3671875 5.796875 10.3671875 5.796875 13 8 C13.3828125 10.765625 13.3828125 10.765625 13 13 C13.99 13 14.98 13 16 13 C16 21.25 16 29.5 16 38 C2.8 38 -10.4 38 -24 38 C-24 29.75 -24 21.5 -24 13 C-23.01 13 -22.02 13 -21 13 C-21.13148437 12.26265625 -21.26296875 11.5253125 -21.3984375 10.765625 C-21 8 -21 8 -18.2265625 5.796875 C-17.03689917 5.0958234 -15.83568502 4.41408883 -14.625 3.75 C-13.72007813 3.2240625 -13.72007813 3.2240625 -12.796875 2.6875 C-5.74695078 -1.38578955 -5.74695078 -1.38578955 0 0 Z M-12 7 C-12 7.33 -12 7.66 -12 8 C-6.72 8 -1.44 8 4 8 C-3.30553323 2.15557342 -4.50172118 2.24147691 -12 7 Z M-18 11 C-18 11.66 -18 12.32 -18 13 C-8.76 13 0.48 13 10 13 C10 12.34 10 11.68 10 11 C0.76 11 -8.48 11 -18 11 Z M-21 16 C-21 16.66 -21 17.32 -21 18 C-9.78 18 1.44 18 13 18 C13 17.34 13 16.68 13 16 C1.78 16 -9.44 16 -21 16 Z M-21 21 C-21 25.29 -21 29.58 -21 34 C-19.68 34.33 -18.36 34.66 -17 35 C-17 30.38 -17 25.76 -17 21 C-18.32 21 -19.64 21 -21 21 Z M-14 21 C-14 25.62 -14 30.24 -14 35 C-12.68 35 -11.36 35 -10 35 C-10 30.38 -10 25.76 -10 21 C-11.32 21 -12.64 21 -14 21 Z M-7 21 C-7 25.62 -7 30.24 -7 35 C-5.02 35 -3.04 35 -1 35 C-1 30.38 -1 25.76 -1 21 C-2.98 21 -4.96 21 -7 21 Z M2 21 C2 25.62 2 30.24 2 35 C3.32 35 4.64 35 6 35 C6 30.38 6 25.76 6 21 C4.68 21 3.36 21 2 21 Z M9 21 C9 25.62 9 30.24 9 35 C10.32 34.67 11.64 34.34 13 34 C13 29.71 13 25.42 13 21 C11.68 21 10.36 21 9 21 Z "
              transform="translate(24,2)"
            />
          </svg>
        </div>
    );
};

export default PaymentConfiguration;